import { Button } from '../components/ui'

interface Props {
  onCreate: () => Promise<void>
  creating: boolean
  error: string | null
}

/** "Race friends" body shared by the desktop card and the phone sheet. */
export function RaceCreatePanel({ onCreate, creating, error }: Props) {
  return (
    <div className="flex flex-col gap-3">
      <p className="text-sm text-slate-500">
        Up to 8 racers slide the same level at once. First to the door wins the round.
      </p>
      <Button
        variant="arcade"
        tone="join"
        className="w-full"
        onClick={() => void onCreate()}
        disabled={creating}
      >
        Create a race
      </Button>
      {error && <p className="text-sm text-rose-600">{error}</p>}
    </div>
  )
}
